/* Filtrous PDP documents - v4, 2026-09-15 (Adelaide).

   v4: application notes show as NOTE CARDS (tests, key result, the other
   Filtrous products used, Read the note + PDF) from
   window.FI_APPNOTES.cardHTML in assets/fi-appnote-view.js, which loads after
   this file; until it is there the plain rows render, and its
   "fi-appnotes-ready" event re-renders. Row styles are scoped to
   .fv3-docs-row so they do not reach the card's buttons and links.

   v3: APPLICATION NOTES ("for the relevant products that the application
   note uses, put that application note under documents"). A product named in
   one of Sunny's published application notes lists that note in its
   Documents tab, after the SDS and IFU. The notes are theme assets
   (assets/fi-appnote-<id>.pdf, the same files the industry pages link from
   snippets/fi-app-notes.liquid). SKU_NOTES below is keyed on the SKUs each
   PDF names in its materials list. Four older molecular notes name retired
   kit SKUs (OSK-RP-0100, OSK-UT-0100, OSK-TR-0100); they are attached to the
   current kit of the same name (OSK-RP-1100, OSK-UT-M100, OSK-TR-1100).
   Notes render immediately; SDS/IFU join when the lookup answers, so a
   product with notes but no SDS still gets the tab.
   v2: "Documents" is the third TAB - [ Specifications | Description |
   Documents ] - instead of a separate block under the tabs.
   v1: SDS + IFU links in a block under the tabs.

   SDS/IFU SOURCE: the same n8n doc-lookup webhook the Document Lookup page
   uses (sections/document-lookup.liquid). It searches the Drive SDS/IFU
   folders by SKU and returns public Drive view links, so a PDF dropped
   into Drive shows up here with no theme edit. The webhook refuses calls
   that do not come from filtrous.com.

   TABS: the row and the Description/Specifications panels belong to
   filtrous-pdp-merch.js (selectTab), and filtrous-fbt.js moves
   Specifications first. This file only appends its own button + panel:
   its button is appended last, so the reorder leaves it third. Merch's
   selectTab() already un-selects this button (it compares data-tab), but
   it only hides its own two panels - so a click on any other tab hides
   the Documents panel here. The panel has no <h2>: ensureTabs() strips
   every H2 child of .fv3-about on each pass.

   - SKU comes from FV3_CONFIG.pdpSku (set in filtrous-v3-app.liquid).
   - One lookup per SKU per browser session (sessionStorage); a failed
     lookup is not cached, so the next page view retries.
   - Waits out instant.page prerendering, so hovering a link does not
     fire lookups for pages nobody opens.
   - Re-asserts on mutation: the app rebuilds the buy column on render.

   Additive asset; remove its loader line in sections/filtrous-v3-app.liquid
   to revert. */
(function () {
  'use strict';

  var cfg = window.FV3_CONFIG || {};
  var SKU = String(cfg.pdpSku || '').trim();
  if (!SKU || !/^[A-Za-z0-9\-]+$/.test(SKU)) return;

  var ENDPOINT = 'https://filtrous.app.n8n.cloud/webhook/doc-lookup';
  var CACHE_KEY = 'fv3-docs-v1:' + SKU.toUpperCase();
  var LABELS = { SDS: 'Safety Data Sheet (SDS)', IFU: 'Instructions for Use (IFU)' };
  var ORDER = ['SDS', 'IFU'];

  /* Theme assets live beside this script on the CDN. */
  var ME = document.currentScript && document.currentScript.src;
  var ASSET_BASE = ME ? ME.split('?')[0].replace(/[^\/]*$/, '') : '';

  var APP_NOTES = {
    'cannabis-pesticides-lcmsms': ['Cannabis pesticide residues by LC-MS/MS', 8],
    'cannabinoid-potency-hplc': ['Cannabinoid potency: 15+ cannabinoids by HPLC', 6],
    'tirzepatide-purity-hplc': ['Tirzepatide purity by HPLC-PDA', 4],
    'tirzepatide-mass-lcms': ['Tirzepatide mass confirmation by LC-MS', 4],
    'ghk-cu-cream-hplc': ['GHK-Cu in cosmetic cream by HPLC-PDA', 4],
    'ghk-cream-mass-lcms': ['GHK mass confirmation in cosmetic cream by LC-MS', 4],
    'uti-multiplex-qpcr': ['UTI panel: 23 pathogens and 6 resistance genes', 12],
    'ecoli-urine-qpcr': ['E. coli in urine by qPCR', 5],
    'rsv-a-swab-qpcr': ['RSV-A in nasopharyngeal swabs by qPCR', 4],
    'respiratory-panel-rt-qpcr': ['Respiratory panel: bacterial and viral targets from swabs', 6],
    'respiratory-viral-rna': ['Respiratory viral RNA: hMPV and parainfluenza 3', 7],
    'bacterial-gdna-qpcr': ['Bacterial genomic DNA for respiratory and UTI panels', 6],
    'whole-blood-dna-rna': ['DNA/RNA recovery from whole blood', 3],
    'nail-fungus-qpcr': ['Nail fungus (E. floccosum) in tough-to-lyse samples', 5],
    'ffpe-dna-rna': ['DNA/RNA recovery from FFPE tissue', 4],
    'ethanol-fermentation-hplc': ['Ethanol fermentation: sugars, alcohols and acids by HPLC-RID', 5]
  };

  var SKU_NOTES = {
    'EXK-BD-0096': ['uti-multiplex-qpcr', 'ecoli-urine-qpcr', 'rsv-a-swab-qpcr', 'respiratory-panel-rt-qpcr',
                    'respiratory-viral-rna', 'bacterial-gdna-qpcr', 'whole-blood-dna-rna', 'ffpe-dna-rna', 'nail-fungus-qpcr'],
    'OSK-UT-M100': ['uti-multiplex-qpcr', 'ecoli-urine-qpcr', 'bacterial-gdna-qpcr'],
    'OSK-TR-1100': ['uti-multiplex-qpcr', 'bacterial-gdna-qpcr'],
    'OSK-RP-1100': ['rsv-a-swab-qpcr', 'respiratory-panel-rt-qpcr', 'respiratory-viral-rna', 'bacterial-gdna-qpcr'],
    'OSK-NF-1100': ['nail-fungus-qpcr'],
    'OSK-WD-M100': ['whole-blood-dna-rna', 'ffpe-dna-rna'],
    'MBP-01-2404': ['cannabis-pesticides-lcmsms', 'tirzepatide-mass-lcms', 'ghk-cream-mass-lcms'],
    'MBP-03-2404': ['cannabis-pesticides-lcmsms', 'tirzepatide-mass-lcms', 'ghk-cream-mass-lcms'],
    'MBP-01-1404': ['tirzepatide-purity-hplc', 'ghk-cu-cream-hplc'],
    'MBP-03-1404': ['tirzepatide-purity-hplc', 'ghk-cu-cream-hplc'],
    'SFN-GR-1013': ['tirzepatide-purity-hplc', 'tirzepatide-mass-lcms', 'ghk-cu-cream-hplc', 'ghk-cream-mass-lcms'],
    'SFN-BR-1025': ['cannabis-pesticides-lcmsms'],
    'CCF-10-4500': ['cannabis-pesticides-lcmsms'],
    'SFN-AR-1025': ['cannabinoid-potency-hplc'],
    'SFN-CQ-1030': ['ethanol-fermentation-hplc']
  };

  var sheets = null;   // [{type, name, href, size}] once the lookup answers
  var notes = (SKU_NOTES[SKU.toUpperCase()] || []).filter(function (id) { return APP_NOTES[id] && ASSET_BASE; })
    .map(function (id) {
      return { type: 'NOTE', id: id, name: APP_NOTES[id][0], pages: APP_NOTES[id][1], href: ASSET_BASE + 'fi-appnote-' + id + '.pdf' };
    });

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fmtSize(n) {
    n = Number(n);
    if (!isFinite(n) || n <= 0) return '';
    return n >= 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.round(n / 1024) + ' KB';
  }

  /* Only public Drive links are rendered from the lookup; anything else in a response is dropped. */
  function safeHref(u) {
    return /^https:\/\/drive\.google\.com\//.test(String(u || '')) ? String(u) : '';
  }

  function normalize(body) {
    var out = [];
    ((body && body.results) || []).forEach(function (r) {
      if (!r || !r.found || !LABELS[r.docType]) return;
      (r.documents || []).forEach(function (d) {
        var href = safeHref(d && d.viewLink);
        if (href) out.push({ type: r.docType, name: d.name || '', href: href, size: d.size });
      });
    });
    out.sort(function (a, b) { return ORDER.indexOf(a.type) - ORDER.indexOf(b.type); });
    return out;
  }

  function readCache() {
    try {
      var v = sessionStorage.getItem(CACHE_KEY);
      return v ? JSON.parse(v) : null;
    } catch (e) { return null; }
  }

  function writeCache(list) {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function allDocs() { return (sheets || []).concat(notes); }

  function css() {
    if (document.getElementById('fv3-docs-css')) return;
    var st = document.createElement('style');
    st.id = 'fv3-docs-css';
    st.textContent =
      '#fv3-app .fv3-tabpanel-docs ul{list-style:none;margin:0;padding:0}' +
      '#fv3-app .fv3-tabpanel-docs li{margin:0}' +
      '#fv3-app .fv3-tabpanel-docs .fv3-docs-row{display:flex;align-items:center;gap:10px;min-height:44px;padding:4px 0;color:var(--navy,#082f4b);text-decoration:none}' +
      '#fv3-app .fv3-tabpanel-docs .fv3-docs-row:hover .fv3-docs-name{text-decoration:underline;text-underline-offset:2px}' +
      '#fv3-app .fv3-tabpanel-docs .fv3-docs-row:focus-visible{outline:3px solid var(--dteal,#0d7d68);outline-offset:2px;border-radius:4px}' +
      '#fv3-app .fv3-tabpanel-docs .fv3-docs-row svg{flex:0 0 auto;width:20px;height:20px;color:var(--dteal,#0d7d68)}' +
      '#fv3-app .fv3-tabpanel-docs .fv3-docs-cards{display:grid;gap:10px;margin-top:6px}' +
      '#fv3-app .fv3-docs-name{font-size:14px;font-weight:600}' +
      '#fv3-app .fv3-docs-name small{display:block;font-size:12.5px;font-weight:500;color:var(--mut,#5b7284)}' +
      '#fv3-app .fv3-docs-meta{margin-left:auto;padding-left:12px;font-size:12.5px;color:var(--mut,#5b7284);white-space:nowrap}' +
      '#fv3-app .fv3-docs-group{margin:12px 0 2px;font-size:12.5px;font-weight:700;color:var(--mut,#5b7284)}' +
      '#fv3-app .fv3-tabpanel-docs .fv3-vh{position:absolute;width:1px;height:1px;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}';
    document.head.appendChild(st);
  }

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="13" y2="17"/></svg>';

  function row(d, label, meta) {
    /* data-appnote: assets/fi-appnote-view.js opens its reading view; the PDF href is the fallback. */
    return '<li><a class="fv3-docs-row" href="' + esc(d.href) + '" target="_blank" rel="noopener"' + (d.id ? ' data-appnote="' + esc(d.id) + '"' : '') + '>' + ICON +
      '<span class="fv3-docs-name">' + label + '</span>' +
      '<span class="fv3-docs-meta">' + meta + '</span>' +
      '<span class="fv3-vh"> (opens in a new tab)</span></a></li>';
  }

  function listHTML() {
    var list = sheets || [];
    var perType = {};
    list.forEach(function (d) { perType[d.type] = (perType[d.type] || 0) + 1; });
    var h = '';
    if (list.length) {
      h += '<ul>' + list.map(function (d) {
        /* Two files of one type (rare) are told apart by file name. */
        var label = LABELS[d.type] + (perType[d.type] > 1 && d.name ? ' - ' + d.name.replace(/\.pdf$/i, '') : '');
        var size = fmtSize(d.size);
        return row(d, esc(label), 'PDF' + (size ? ' &middot; ' + esc(size) : ''));
      }).join('') + '</ul>';
    }
    if (notes.length) {
      var api = window.FI_APPNOTES;
      var cards = !!(api && api.cardHTML);
      h += '<p class="fv3-docs-group" id="fv3-docs-notes-h">Applications</p><ul' + (cards ? ' class="fv3-docs-cards"' : '') + ' aria-labelledby="fv3-docs-notes-h">' +
        notes.map(function (d) {
          var card = cards ? api.cardHTML(d.id, { exclude: SKU }) : '';
          return card ? '<li>' + card + '</li>' : row(d, esc(d.name), 'PDF &middot; ' + d.pages + ' pages');
        }).join('') + '</ul>';
    }
    return h;
  }

  function signature() {
    return allDocs().map(function (d) { return d.href; }).join('|');
  }

  function showDocs(about) {
    [].slice.call(about.querySelectorAll('.fv3-tab')).forEach(function (t) {
      t.setAttribute('aria-selected', t.getAttribute('data-tab') === 'docs' ? 'true' : 'false');
    });
    [].slice.call(about.querySelectorAll('.fv3-about-body, .fv3-tabpanel-specs')).forEach(function (p) {
      p.hidden = true;
    });
    var panel = about.querySelector('.fv3-tabpanel-docs');
    if (panel) panel.hidden = false;
  }

  function place() {
    if (!allDocs().length) return;
    var about = document.querySelector('#fv3-app .fv3-buy .fv3-about');
    var row0 = about && about.querySelector('.fv3-tabrow');
    if (!row0) return;   // merch builds the tab row; the next mutation pass retries

    var sig = SKU + '#' + signature() + (window.FI_APPNOTES && window.FI_APPNOTES.cardHTML ? '#cards' : '');
    var btn = row0.querySelector('[data-tab="docs"]');
    var panel = about.querySelector('.fv3-tabpanel-docs');
    if (btn && panel && panel.getAttribute('data-sig') === sig) {
      if (row0.lastElementChild !== btn) row0.appendChild(btn);
      return;
    }
    css();

    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fv3-tab';
      btn.id = 'fv3-tab-docs';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('data-tab', 'docs');
      btn.setAttribute('aria-selected', 'false');
      btn.setAttribute('aria-controls', 'fv3-tabpanel-docs');
      btn.textContent = 'Documents';
      btn.addEventListener('click', function () { showDocs(about); });
      row0.appendChild(btn);
    }

    var wasOpen = panel && !panel.hidden;
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'fv3-tabpanel-docs';
      panel.id = 'fv3-tabpanel-docs';
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', 'fv3-tab-docs');
      about.appendChild(panel);
    }
    panel.setAttribute('data-sig', sig);
    panel.hidden = !wasOpen;
    panel.innerHTML = listHTML();

    /* Any other tab: merch's selectTab() handles its panels, this hides ours. */
    if (!row0.getAttribute('data-docs-wired')) {
      row0.setAttribute('data-docs-wired', '1');
      row0.addEventListener('click', function (e) {
        var t = e.target.closest && e.target.closest('.fv3-tab');
        if (!t || t.getAttribute('data-tab') === 'docs') return;
        var p = about.querySelector('.fv3-tabpanel-docs');
        if (p) p.hidden = true;
      });
    }
  }

  function lookup() {
    var cached = readCache();
    if (cached) { sheets = cached; return Promise.resolve(); }
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sku: SKU, doc_types: ORDER })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (body) {
        if (!body || body.ok === false) return;   // not cached: retry next view
        sheets = normalize(body);
        writeCache(sheets);
      })
      .catch(function () {});
  }

  var observing = false;
  function observe() {
    if (observing || !allDocs().length) return;
    observing = true;
    var mount = document.getElementById('fv3-app') || document.body;
    new MutationObserver(place).observe(mount, { childList: true, subtree: true });
  }

  function boot() {
    /* Application notes are known up front: show them without waiting on the lookup. */
    if (notes.length) {
      document.addEventListener('fi-appnotes-ready', place);
      place();
      observe();
    }
    lookup().then(function () {
      if (!allDocs().length) return;
      place();
      observe();
    });
  }

  function start() {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }

  if (document.prerendering) {
    document.addEventListener('prerenderingchange', start, { once: true });
  } else {
    start();
  }
})();
